// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterSearchWrapper_root__30XsG"};